import { Observer } from './Observer';
import Handlebars from 'Shared/handlebars';
/**
 * Autocompleter
 * Copyright (c) 2008-2009 by Harald Kirschner
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 * THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * http://digitarald.de/project/autocompleter/
 *
 * @version		1.1.2
 *
 * @license		MIT-style license
 * @author		Harald Kirschner <mail [at] digitarald.de>
 * @copyright	Author
 */

// eslint-disable-next-line no-var
export var Autocompleter = (window.Autocompleter = new Class({
   Implements: [Options, Events],

   options: {
      onOver: function () {},
      onSelect: function () {},
      onSelection: function () {},
      onShow: function () {},
      onHide: function () {},
      onBlur: function () {},
      onFocus: function () {},
      minLength: 1,
      markQuery: true,
      width: 'inherit',
      maxChoices: 10,
      injectChoice: null,
      customChoices: null,
      emptyChoices: null,
      visibleChoices: false,
      className: 'autocompleter-choices',
      zIndex: 42,
      delay: 50,
      observerOptions: {},
      fxOptions: {},

      autoSubmit: false,
      overflow: false,
      overflowMargin: 25,
      selectFirst: true,
      filter: null,
      filterCase: false,
      filterSubset: true,
      forceSelect: false,

      // Changed this default to false to make the autocomplete less
      // "aggressive". See ticket #6436.
      selectMode: false,

      choicesMatch: null,

      multiple: false,
      separator: ', ',
      separatorSplit: /\s*[,;]\s*/,
      autoTrim: false,
      allowDupes: false,

      relative: false,
      submitOnEnter: true,
   },

   initialize: function (element, options) {
      this.element = $(element);
      this.setOptions(options);
      this.build();
      this.observer = new Observer(
         this.element,
         this.prefetch.bind(this),
         Object.merge(
            {
               delay: this.options.delay,
            },
            this.options.observerOptions
         )
      );
      this.queryValue = null;
      if (this.options.filter) {
         this.filter = this.options.filter.bind(this);
      }
      let mode = this.options.selectMode;
      this.typeAhead = mode == 'type-ahead';
      this.selectMode = mode === true ? 'selection' : mode;
   },

   /**
    * build - Initialize DOM
    *
    * Builds the html structure for choices and appends the events to the element.
    * Override this function to modify the html generation.
    */
   build: function () {
      if ($(this.options.customChoices)) {
         this.choices = this.options.customChoices;
      } else {
         this.choices = new Element('ul', {
            class: this.options.className,
            styles: {
               zIndex: this.options.zIndex,
            },
         })
            .hide()
            .inject(document.body, 'top');
         this.relative = false;
         if (this.options.relative) {
            this.choices.inject(this.element, 'after');
            this.relative = this.element.getOffsetParent();
         }
         this.fix = new OverlayFix(this.choices).hide();
      }
      if (!this.options.separator.test(this.options.separatorSplit)) {
         this.options.separatorSplit = this.options.separator;
      }

      this.choices.setStyles({ height: 0 });
      this.addEvents();
   },
   addEvents: function () {
      this.element
         .setProperty('autocomplete', 'off')
         .addEvent('keydown', this.onCommand.bind(this))
         .addEvent('click', this.onCommand.bind(this, false))
         .addEvent('focus', () => {
            this.toggleFocus(true);
         });
      window.addEvent('click', () => {
         if (!this.inputHasFocus()) {
            this.toggleFocus(false);
         }
      });
   },

   destroy: function () {
      if (this.fix) {
         this.fix.destroy();
      }
      this.choices = this.selected = this.choices.destroy();
   },

   toggleFocus: function (state) {
      this.focussed = state;
      if (state) {
         this.showChoices();
      } else {
         this.hideChoices(true);
      }
      this.fireEvent(state ? 'onFocus' : 'onBlur', [this.element]);
   },

   onCommand: function (e) {
      if (!e && this.focussed) {
         return this.prefetch();
      }
      if (e && e.key && !e.shift) {
         switch (e.key) {
            case 'enter': {
               if (this.selected && this.visible) {
                  this.choiceSelect(this.selected);
                  return !!this.options.autoSubmit;
               }

               if (this.element.value != this.opted) {
                  // Prevent the enter event from bubbling up to the parent form (if there is one)
                  e.stop();
                  this.fireEvent('onSelection', [this.element.value]);
                  return this.options.submitOnEnter;
               }

               break;
            }
            case 'up':
            case 'down': {
               if (!this.prefetch() && this.queryValue !== null) {
                  // Allow up/down navigation in textareas when the choices aren't shown
                  if (!this.visible) {
                     return true;
                  }
                  let up = e.key == 'up';

                  this.choiceOver(
                     (this.selected || this.choices)[
                        this.selected
                           ? up
                              ? 'getPrevious'
                              : 'getNext'
                           : up
                             ? 'getLast'
                             : 'getFirst'
                     ](this.options.choicesMatch),
                     true
                  );
               }
               return false;
            }
            case 'esc':
            case 'tab': {
               this.hideChoices(true);
               break;
            }
         }
      }
      return true;
   },

   setSelection: function (finish) {
      let input = this.selected.inputValue,
         value = input;
      let start = this.queryValue.length,
         end = input.length;
      if (input.slice(0, Math.max(0, start)).toLowerCase() != this.queryValue.toLowerCase()) {
         start = 0;
      }
      if (this.options.multiple) {
         let split = this.options.separatorSplit;
         value = this.element.value;
         start += this.queryIndex;
         end += this.queryIndex;
         let old = value.slice(this.queryIndex).split(split, 1)[0];
         value =
            value.slice(0, Math.max(0, this.queryIndex)) +
            input +
            value.slice(this.queryIndex + old.length);
         if (finish) {
            let tokens = value.split(this.options.separatorSplit).filter(function (entry) {
               return this.test(entry);
            }, /[^\s,]+/);
            if (!this.options.allowDupes) {
               tokens = [].combine(tokens);
            }
            let sep = this.options.separator;
            value = tokens.join(sep) + sep;
            end = value.length;
         }
      }
      this.observer.setValue(value);
      this.opted = value;
      if (finish || this.selectMode == 'pick') {
         start = end;
      }
      this.element.focus();
      this.element.setSelectionRange(start, end);
      this.fireEvent('onSelection', [this.selected, finish, this.queryValue]);
   },

   showChoices: function () {
      // Don't show any choices if the user has moved off of this input.
      if (!this.inputHasFocus()) {
         return;
      }

      let match = this.options.choicesMatch,
         first = this.choices.getFirst(match);
      this.selected = this.selectedValue = null;
      if (!first) {
         return;
      }
      if (!this.options.customChoices) {
         this.positionRelativeToInput(this.choices);
      }
      if (!this.visible) {
         this.visible = true;
         this.choices.setStyle('display', '');
         this.choices.setStyle('height', 'auto');
         this.fireEvent('onShow', [this.element, this.choices]);
      }
      if (this.options.selectFirst || this.typeAhead || first.inputValue == this.queryValue) {
         this.choiceOver(first, this.typeAhead);
      }
      let items = this.choices.getChildren(match),
         max = this.options.maxChoices;
      let height = '';
      if (items.length > max) {
         let item = items[max - 1];
         height = item.getCoordinates(this.choices).bottom;
      }
      this.choices.setStyles({ height: height });
      if (this.fix) {
         this.fix.show();
      }
      if (this.options.visibleChoices) {
         let scroll = document.getScroll(),
            size = document.getSize(),
            coords = this.choices.getCoordinates();
         if (coords.top > 0) {
            if (coords.right > scroll.x + size.x) {
               scroll.x = coords.right - size.x;
            }
            if (coords.bottom > scroll.y + size.y) {
               scroll.y = coords.bottom - size.y;
            }
            window.scrollTo(Math.min(scroll.x, coords.left), Math.min(scroll.y, coords.top));
         }
      }
   },

   hideChoices: function (clear) {
      if (clear) {
         let value = this.element.value;
         if (this.options.forceSelect && this.opted !== undefined) {
            value = this.opted;
         }
         if (this.options.autoTrim) {
            value = value
               .split(this.options.separatorSplit)
               .filter(Boolean)
               .join(this.options.separator);
         }
         this.observer.setValue(value);
      }
      if (!this.visible) {
         return;
      }
      this.visible = false;
      if (this.selected) {
         this.selected.removeClass('autocompleter-selected');
      }
      this.observer.clear();
      this.choices.setStyles({ height: 0, display: 'none' });
      this.fireEvent('onHide', [this.element, this.choices]);
   },

   prefetch: function () {
      let value = this.element.value,
         query = value;
      if (this.options.multiple) {
         let split = this.options.separatorSplit;
         let values = value.split(split);
         // eslint-disable-next-line no-var
         var index = this.element.selectionStart;
         let toIndex = value.slice(0, Math.max(0, index)).split(split);
         let last = toIndex.length - 1;
         index -= toIndex[last].length;
         query = values[last];
      }
      if (query.length < this.options.minLength) {
         this.hideChoices();
      } else {
         if (query === this.queryValue || (this.visible && query == this.selectedValue)) {
            if (this.visible) {
               return false;
            }
            this.showChoices();
         } else {
            this.queryValue = query;
            this.queryIndex = index;
            this.query();
         }
      }
      return true;
   },

   /**
    * It's important to set the overflow value for the choices container before
    * we inject the choices because otherwise the items will have their width
    * set according to the previous value. This leaves a gutter on the right
    * when switching from 'scroll' to 'hidden' (which can easily happen when
    * going from a long list to a short one).
    */
   update: function (tokens) {
      this.choices.empty();
      let type = tokens && typeOf(tokens);
      if (!type || (type == 'array' && !tokens.length) || (type == 'hash' && !tokens.getLength())) {
         (this.options.emptyChoices || this.hideChoices).call(this);
      } else {
         if (this.options.maxChoices < tokens.length && !this.options.overflow) {
            tokens.length = this.options.maxChoices;
         }
         let overflowY = 'hidden';
         this.overflow = false;
         if (tokens.length > this.options.maxChoices) {
            overflowY = 'scroll';
            this.overflown = true;
         }
         this.choices.setStyle('overflow-y', overflowY);
         tokens.each(
            this.options.injectChoice ||
               function (token) {
                  let choice = new Element('li', { html: this.markQueryValue(token) });
                  choice.inputValue = token;
                  this.addChoiceEvents(choice).inject(this.choices);
               },
            this
         );
         this.showChoices();
      }
      this.choices.scrollTop = 0;
   },

   choiceOver: function (choice, selection) {
      if (!choice || choice == this.selected) {
         return;
      }
      if (this.selected) {
         this.selected.removeClass('autocompleter-selected');
      }
      this.selected = choice.addClass('autocompleter-selected');
      this.fireEvent('onSelect', [this.element, this.selected, selection]);
      if (!this.selectMode) {
         this.opted = this.element.value;
      }
      if (!selection) {
         return;
      }
      this.selectedValue = this.selected.inputValue;
      if (this.overflown) {
         let coords = this.selected.getCoordinates(this.choices.getFirst()),
            margin = this.options.overflowMargin,
            top = this.choices.scrollTop,
            height = this.choices.offsetHeight,
            bottom = top + height;
         if (coords.top - margin < top && top) {
            this.choices.scrollTop = Math.max(coords.top - margin, 0);
         } else if (coords.bottom + margin > bottom) {
            this.choices.scrollTop = Math.min(coords.bottom - height + margin, bottom);
         }
      }
      if (this.selectMode) {
         this.setSelection();
      }
   },

   choiceSelect: function (choice) {
      if (choice) {
         this.choiceOver(choice);
      }

      if (choice.hasClass('autocompleter-selected')) {
         this.setSelection(true);
      } else {
         // This is a bugfix for when clicking sometimes does nothing. I don't
         // know why it happens, but this is the best fix I could come up with.
         // - Dave
         this.fireEvent('onSelection', [choice, true]);
      }

      this.queryValue = false;
      this.hideChoices();
   },

   filter: function (tokens) {
      return (tokens || this.tokens).filter(
         function (token) {
            return this.test(token);
         },
         new RegExp(
            (this.options.filterSubset ? '' : '^') + this.queryValue.escapeRegExp(),
            this.options.filterCase ? '' : 'i'
         )
      );
   },

   /**
    * markQueryValue
    *
    * Marks the queried word in the given string with <span class="autocompleter-queried">*</span>
    * Call this i.e. from your custom parseChoices, same for addChoiceEvents
    *
    * @param		{String} Text
    * @return		{String} Html
    */
   markQueryValue: function (str) {
      // Since we're claiming this is html when we return it, we better turn
      // unsafe text into safe html before doing a search/replace
      str = (str || '').encodeHtml();
      // This is here only so if the thing we are searching for looks different
      // when encoded in the line above, we can still find it.
      let query = (this.queryValue || '').encodeHtml();
      let regex = new RegExp(
         '(' + (this.options.filterSubset ? '' : '^') + query.escapeRegExp() + ')',
         this.options.filterCase ? '' : 'i'
      );
      // Since we are encoding the incoming data and then appending html to it,
      // we can safely call this html.
      return !this.options.markQuery || !query || query == str
         ? str
         : new Handlebars.SafeString(
              str.replace(regex, '<span class="autocompleter-queried">$1</span>')
           );
   },

   /**
    * addChoiceEvents
    *
    * Appends the needed event handlers for a choice-entry to the given element.
    *
    * @param		{Element} Choice entry
    * @return		{Element} Choice entry
    */
   addChoiceEvents: function (el) {
      return el.addEvents({
         mouseover: this.choiceOver.bind(this, el),
         mousedown: this.choiceSelect.bind(this, el),
      });
   },

   /**
    * Returns true iff the input element is currently focused.
    */
   inputHasFocus: function () {
      return this.element === document.activeElement;
   },

   positionRelativeToInput: function (el) {
      let pos = this.element.getCoordinates(this.relative),
         width = this.options.width || 'auto';
      if (width === true || width == 'inherit') {
         width = pos.width;
      }
      // Bugfix wrong position in Safari when the textbox scrolls from long
      // text. -Dave
      pos.left += this.element.getScroll().x;
      el.setStyles({
         left: pos.left,
         top: pos.bottom + 10,
         width: width,
      });
   },
}));

const OverlayFix = new Class({
   initialize: function (el) {
      if (Browser.ie) {
         this.element = $(el);
         this.relative = this.element.getOffsetParent();
         this.fix = new Element('iframe', {
            frameborder: '0',
            scrolling: 'no',
            src: 'javascript:false;',
            styles: {
               position: 'absolute',
               border: 'none',
               display: 'none',
               filter: 'progid:DXImageTransform.Microsoft.Alpha(opacity=0)',
            },
         }).inject(this.element, 'after');
      }
   },

   show: function () {
      if (this.fix) {
         let coords = this.element.getCoordinates(this.relative);
         delete coords.right;
         delete coords.bottom;
         this.fix.setStyles(
            Object.append(coords, {
               display: '',
               zIndex: (this.element.getStyle('zIndex') || 1) - 1,
            })
         );
      }
      return this;
   },

   hide: function () {
      if (this.fix) {
         this.fix.setStyle('display', 'none');
      }
      return this;
   },

   destroy: function () {
      if (this.fix) {
         this.fix = this.fix.destroy();
      }
   },
});

/* compatibility */

Autocompleter.Base = Autocompleter;
